import { api } from 'src/boot/axios.js';

export default {

  authenticateUser(payload) {
    return api.post('/auth', payload);
  },

  fetchUserInformation() {
    return api.get('/user');
  },

  saveUserSettings(payload) {
    return api.post('/user', payload);
  },

  saveUserAddress(payload) {
    return api.post('/userAddress', payload);
  },

  saveUserPushToken(payload) {
    return api.post('/user', { androidPushToken: payload });
  },

  updateUserDefaultAddress(payload) {
    return api.put(`/userAddress/${payload.id}`, { default: payload.default });
  },

  updateUserAddress(payload) {
    return api.put(`/userAddress/${payload.id}`, payload);
  },

  deleteUserAddress(payload) {
    return api.delete(`/userAddress/${payload}`);
  },

  fetchCategoryById(id) {
    return api.get(`/category/${id}`);
  },

  fetchCategories() {
    return api.get('/category');
  },

  fetchProductById(productId) {
    return api.get(`/product/${productId}`);
  },

  checkIfValidCouponCode({ coupon, deliveryMethodId }) {
    return api.get(`/coupon/${coupon}/${deliveryMethodId}`);
  },

  fetchDeliveryMethod(payload) {
    return payload ? api.get(`/deliveryMethod/${payload}`)
      : api.get('/deliveryMethod');
  },

  fetchPaymentMethod(payload) {
    return payload ? api.get(`/paymentMethod/${payload}`)
      : api.get('/paymentMethod');
  },

  fetchLocations(payload) {
    return payload ? api.get(`/location/${payload}`)
      : api.get('/location');
  },

  fetchDeliveryMethods() {
    return api.get('/deliveryMethod');
  },

  submitUsersOrder(payload) {
    return api.post('/order', payload);
  },

  setOrderStatusArrived(orderId) {
    return api.put(`/order/${orderId}`, {
      status: 9,
    });
  },

  fetchLastOrderFromAPI() {
    return api.get('/lastOrder');
  },

  fetchAllOrdersFromAPI() {
    return api.get('/orders');
  },

  fetchUserPaymentMethod() {
    return api.get('/userPaymentMethod');
  },

  saveNewUserPaymentMethod(payload) {
    return api.post('/userPaymentMethod', payload);
  },

  removeUserPaymentMethodById(payload) {
    return api.delete(`/userPaymentMethod/${payload}`);
  },

  fetchUserItems() {
    return api.get('/userFavorite');
  },

  saveUserItem(payload) {
    return api.post('/userFavorite', payload);
  },

  removeUserItem(payload) {
    return api.delete(`/userFavorite/${payload}`);
  },

  updateUserItem(payload) {
    return api.put(`/userFavorite/${payload.id}`, { title: payload.title });
  },
};
